<template>
    <div class="origin-desc">
        <div class="desc-c">
            <span class="desc-label" @click="showDialog">作者声明</span>
            <div class="desc-content" v-if="isShowDialog">
                {{ info }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        desc: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isShowDialog: false,
            info: this.desc
        };
    },
    methods: {
        showDialog() {
            this.isShowDialog = true
            if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                window.sohuSpm.sendAction({
                    acode: '10628'
                });
            }
        },
    },
    mounted() {
        window.addEventListener("scroll", () => {
            this.isShowDialog = false;
        });
        $("body").on("click", (e) => {
            if (
                !e.target.getAttribute("class") ||
                e.target.getAttribute("class").indexOf("desc-label") < 0
            ) {
                this.isShowDialog = false;
            }
        });
    },
};
</script>
<style lang="less" scoped>
.origin-desc {
    position: relative;
    .desc-label {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 56px;
        border-radius: 24px;
        color: #656565;
        font-size: 24px !important; /*px*/
        letter-spacing: 0.44px;
        line-height: 24px; /*px*/
    }
    .desc-content {
        z-index: 10;
        position: absolute;
        right: 0px;
        top: 70px;
        width: 300px;
        padding: 14px 10px 14px 20px;
        background-size: cover;
        box-shadow: 0px 3px 12px 0px rgba(51, 51, 51, 0.1);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        line-height: 32px;
        color: #666666;
        font-size: 22px; /*px*/
        &::before {
            content: "";
            width: 0;
            height: 0;
            border: 5px solid transparent; /*no*/
            position: absolute;
            top: -10px; /*no*/
            right: 30px;
            border-bottom-color: #ffffff;
        }
    }
}
</style>
